import { render, staticRenderFns } from "./fitossanitaria.vue?vue&type=template&id=5725a9ee&"
import script from "./fitossanitaria.vue?vue&type=script&lang=js&"
export * from "./fitossanitaria.vue?vue&type=script&lang=js&"
import style0 from "./fitossanitaria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports